import Dialog from '@mui/material/Dialog'
import { forwardRef, useImperativeHandle, useState } from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { makePostRequest } from 'utils/api'
import { sanatizeServerError } from 'utils/helpers'
import urls from 'utils/urls'
import { GeneralInformationForm } from './GeneralInformationForm'
import React from 'react'
import { useForm } from 'react-hook-form'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const BucketListFormDialog = forwardRef((props, ref) => {
  const { handleUpdateList, selectedRows, documents } = props
  const [activeDocument, setActiveDocument] = useState({})
  const [open, setOpen] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  // const [ utilisationType, setUtilisationType ] = useState( 1 )
  const [finalPayload, setFinalPayload] = useState({})
  const [step, setStep] = useState(0)
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Nom: '',
      Description: '',
      Categorie: '',
      Prix: '',
      Devise: '',
      Temps: '',
      DateObjectif: '',
      Duree: '',
      Statut: '',
      // Datedecreation: '',
    },
  })

  const handleClickOpen = (edit) => {
    if (edit) {
      const activeObj = documents.results.find((v) => v.id === selectedRows[0])
      setActiveDocument({ ...activeObj })
    }
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  useImperativeHandle(ref, () => ({
    handleClickOpen,
    handleClose,
  }))

  const handleSubmitData = async (data) => {
    const payload = {
      ...finalPayload,
    }
    // const Categorie = CATEGORIE.find( ( v ) => v.id === CategorieType )
    // payload[ utilistation.value ] = data
    let response = null
    response = await makePostRequest(urls.crudBucketList, payload, {}, true)

    // if ( activeDocument.utilisation )
    // {
    //   response = await makePutRequest( urls.crudBucketList + activeDocument.id + '/', payload, {} )
    // }
    if (response.status === 201 || response.status === 200) {
      handleUpdateList(response.data, activeDocument)
      await makePostRequest('/api/Personnal/BucketList/', payload, {}, true)
      handleClose()
      setStep(0)
    } else {
      const error = sanatizeServerError(response.data)
      const { Nom, Description, Categorie, Prix, Devise, Temps, DateObjectif, Duree, Statut } =
        error
      if (
        Nom ||
        Description ||
        Categorie ||
        Prix ||
        Devise ||
        Temps ||
        DateObjectif ||
        Duree ||
        Statut
      ) {
        setStep(0)
      } else {
        setStep(1)
      }
      setFormErrors(error)
    }
  }

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <Dialog fullWidth maxWidth="xs" onClose={handleClose}></Dialog>
        <DialogTitle color={'black'}>Créer un rêve</DialogTitle>
        <GeneralInformationForm
          setStep={setStep}
          formErrors={formErrors}
          // setUtilisationType={setUtilisationType}
          setFinalPayload={setFinalPayload}
          handleClose={handleClose}
          activeDocument={activeDocument}
        />
      </Dialog>
    </>
  )
})

export default BucketListFormDialog
